<template>
  <v-layout column align-center>
    <p class="headline font-weight-bold mb-3 text-center primary--text">
      Selecting the days you want to be notified on
    </p>
    <p class="align-self-start">
      Select the days of the week that you commute on with the week-day buttons. You may also select a date-range for which these notifications are active - outside this range, you will NOT receive notifications. If you dont want to specify a range, you can select "Onwards," and the notifications will continue until you cancel them.
    </p>
    <img v-if="$vuetify.breakpoint.xs" src="@/assets/help/days of week_mobile.png" />
    <img v-else src="@/assets/help/days of week.png" />
    <span class="caption">
      If the button is blue, you will receive notifications on those days. If a button is greyed out, it means the trip you selected from the timetable does not run on those days of the week.
    </span>
    <img v-if="$vuetify.breakpoint.xs" src="@/assets/help/dates_mobile.png" />
    <img v-else src="@/assets/help/dates.png" />
    <span class="caption">
      Select the date range by clicking on the fields marked with a calendar: "Start date" and "Stop date". You can then click on the dates you want.
    </span>
  </v-layout>
</template>

<script>
export default {
  data: () => ({

  }),
};
</script>
<style scoped>
  >>>img {
    border:1px solid black;
    max-width:100%;
  }

    >>>p {
      margin:0 16px;
    }
    >>>span {
      margin:0 16px;
      text-align:center;
    }

  @media screen and (min-width: 600px) {
    >>>img {
          margin:12px;
    }

  }
</style>
